export default "__VITE_ASSET__D$Zd4L8R__"